import jwtDecode from 'jwt-decode';

export function decodeToken(token) {
  try {
    return jwtDecode(token);
  } catch (e) {
    return {};
  }
}

export function saveAuth(auth) {
  localStorage.setItem('auth', JSON.stringify(auth));
}

export function loadAuth() {
  return JSON.parse(localStorage.getItem('auth') || '{}') || {};
}

export function isProd() {
  const host = window.location.host;
  return host.indexOf('admin') > -1 && host.indexOf('stg') < 0;
}

const GAME_EVENT_TYPES = {
  "/app/calendar/close": {
    desc: "Close calendar"
  },
  "/app/calendar/open": {
    desc: "Open calendar"
  },
  "/app/calendar/restore": {
    desc: "Restore calendar window"
  },
  "/app/document/close": {
    desc: "Close document"
  },
  "/app/document/open": {
    desc: "Open document"
  },
  "/app/document/restore": {
    desc: "Restore document window"
  },
  "/app/email/close": {
    desc: "Close email app"
  },
  "/app/email/open": {
    desc: "Open email app"
  },
  "/app/email/restore": {
    desc: "Restore email app window"
  },
  "/app/intranet/close": {
    desc: "Close intranet"
  },
  "/app/intranet/open": {
    desc: "Open intranet"
  },
  "/app/intranet/restore": {
    desc: "Restore intranet window"
  },
  "/app/new_email/close": {
    desc: "Close new email app"
  },
  "/app/new_email/open": {
    desc: "Open new email app"
  },
  "/app/sms/close": {
    desc: "Close SMS app"
  },
  "/app/sms/open": {
    desc: "Open SMS app"
  },
  "/app/sms/restore": {
    desc: "Restore SMS app window"
  },
  "/calendar/event/hide": {
    desc: "Hide calendar event"
  },
  "/calendar/event/new/cancel": {
    desc: "Cancel creating new calendar event"
  },
  "/calendar/event/new/create": {
    desc: "Create new calendar event"
  },
  "/calendar/event/new/field/options/offer": {
    desc: "Offer field options for new calendar event"
  },
  "/calendar/event/new/field/options/remove": {
    desc: "Remove field value for new calendar event"
  },
  "/calendar/event/new/field/options/select": {
    desc: "Select field value for new calendar event"
  },
  "/calendar/event/new/field/value/set": {
    desc: "Set field value for new calendar event"
  },
  "/calendar/event/new/guests/add": {
    desc: "Add guest for new calendar event"
  },
  "/calendar/event/new/guests/offer": {
    desc: "Offer guests for new calendar event"
  },
  "/calendar/event/new/guests/remove": {
    desc: "Remove guest for new calendar event"
  },
  "/calendar/event/new/start": {
    desc: "Start creating new calendar event"
  },
  "/calendar/event/show": {
    desc: "Show calendar event"
  },
  "/calendar/week/next": {
    desc: "Show next week in calendar"
  },
  "/calendar/week/prev": {
    desc: "Show previous week in calendar"
  },
  "/coach/invoke": {
    desc: "Invoke coach"
  },
  "/coach/messages/confirm": {
    desc: "Confirm coach message"
  },
  "/dialogue/answers/select": {
    desc: "Select dialogue answer"
  },
  "/dialogue/interrupt": {
    desc: "Interrupt dialogue"
  },
  "/dialogue/start": {
    desc: "Start dialogue"
  },
  "/document/field/hints/use": {
    desc: "Use document field hint"
  },
  "/document/field/options/offer": {
    desc: "Offer document field options"
  },
  "/document/field/options/remove": {
    desc: "Remove document field option"
  },
  "/document/field/options/select": {
    desc: "Select document field option"
  },
  "/document/field/value/set": {
    desc: "Set document field value"
  },
  "/document/save": {
    desc: "Save document"
  },
  "/email/folder/change": {
    desc: "Change email folder"
  },
  "/email/folder/open": {
    desc: "Open email folder"
  },
  "/email/open": {
    desc: "Open email"
  },
  "/email/options/select": {
    desc: "Select email option"
  },
  "/intranet/articles/open": {
    desc: "Open intranet article"
  },
  "/intranet/categories/open": {
    desc: "Open intranet category"
  },
  "/new_email/back": {
    desc: "Return from new email"
  },
  "/new_email/contacts": {
    desc: "Offer new email contacts"
  },
  "/new_email/contacts/add": {
    desc: "Add new email contact"
  },
  "/new_email/contacts/remove": {
    desc: "Remove new email contact"
  },
  "/new_email/field/options": {
    desc: "Offer new email field options"
  },
  "/new_email/field/options/remove": {
    desc: "Remove new email field option"
  },
  "/new_email/field/options/select": {
    desc: "Select new email field option"
  },
  "/new_email/field/value/set": {
    desc: "Set new email field value"
  },
  "/new_email/send": {
    desc: "Send new email"
  },
  "/slide/confirm": {
    desc: "Confirm slide"
  },
  "/sms/new/options/select": {
    desc: "Select new SMS option"
  },
  "/sms/new/send": {
    desc: "Send new SMS"
  },
  "/sms/thread_list/open": {
    desc: "Open SMS thread list"
  },
  "/sms/thread/open": {
    desc: "Open SMS thread"
  },
  "/tutorial/step/confirm": {
    desc: "Confirm tutorial step"
  },
  "/project_master/view/process": {
    desc: "Process PM view"
  },
  "/project_master/view/open": {
    desc: "Open PM view"
  },
  "/project_master/project/assign": {
    desc: "Assign project in PM"
  },
  "/project_master/task/assign": {
    desc: "Assign task in PM"
  },
  "/app/project_master/open": {
    desc: "Open ProjectMaster"
  },
  "/app/project_master/close": {
    desc: "Close ProjectMaster"
  }
};

export function describeEvent(type) {
  const eventType = GAME_EVENT_TYPES[type];
  if (!eventType) {
    return `Unknown type '${type}'`;
  }
  return eventType.desc;
}

export function formatDuration(durationInSeconds) {
  const sec = durationInSeconds % 60;
  const minutes = Math.floor(durationInSeconds / 60);
  const min = minutes % 60;
  const hours = Math.floor(minutes / 60);
  let res = '';
  if (hours > 0) {
    res += `${hours} h ${min} min `;
  } else if (min > 0) {
    res += `${min} min `;
  }
  res += `${sec} sec`;
  return res;
}



// WEBPACK FOOTER //
// ./src/utils/Utils.js